import axios from "axios";
import { store } from "./store";
import router from "@/router.js";
import SweetAlert from "./helpers/sweetAlert";
import toast from "./helpers/toast";

export const CancelToken = axios.CancelToken;

export class Cancelable {
  constructor() {
    this.cancelFunctions = [];
  }

  async request(url, method, body = {}) {
    let cancelIndex;
    const self = this;
    const cancel = {};

    cancel.cancelToken = new CancelToken(function executor(c) {
      cancelIndex = self.cancelFunctions.push(c) - 1;
    });

    if (method === "get") {
      body = { ...body, ...cancel };
      return Http.get(url, body)
        .then((response) => {
          this.cancelFunctions.splice(cancelIndex, 1);
          return response;
        })
        .catch((err) => {
          this.cancelFunctions.splice(cancelIndex, 1);
          throw TypeError(err);
        });
    } else if (method === "post") {
      return Http.post(url, body, cancel)
        .then((response) => {
          this.cancelFunctions.splice(cancelIndex, 1);
          return response;
        })
        .catch((err) => {
          this.cancelFunctions.splice(cancelIndex, 1);
          throw TypeError(err);
        });
    }
  }

  cancelRequests() {
    this.cancelFunctions.forEach((cancel) => {
      cancel();
    });
  }
}

export const Http = axios.create({
  baseURL: "api/v2",
  headers: {
    common: {
      "Content-Type": "application/json",
    },
  },
});

export const AuthHttp = axios.create({
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

// Interceptors
Http.interceptors.request.use(function (request) {
  request.headers.Authorization = "Bearer " + store.state.authStore.token;
  return request;
});

Http.interceptors.response.use(
  (response) => {
    if (response.data.error) {
      SweetAlert.alertBox(response.data.message, 2000, "error");
      return Promise.reject(response);
    } else {
      return response;
    }
  },
  (error) => {
    if (error.response.status === 405) {
      SweetAlert.alertBox(
        "You don't have permission to perform this action!",
        2000,
        "error"
      );
    } else if (error.response.status === 401) {
      SweetAlert.alertBox("Unauthorized!", 2000, "error");
      store.commit("reset");
      router.push({ name: "login" }, { params: { logout: true } });
    } else if (error.response.status === 500) {
      SweetAlert.alertBox(
        "An error occurred, please contact administrator!",
        4000,
        "warning"
      );
      store.commit("reset");
      router.push({ name: "login" }, { params: { logout: true } });
    }
    return Promise.reject(error);
  }
);

// Error handler
export function errorHandler(err, defaultMsg = null) {
  if (typeof err === "undefined" || typeof err.response === "undefined" || !err)
    return;

  let msg;
  if (
    typeof ((err || {}).response || {}).status !== "undefined" &&
    err.response.status === 404
  ) {
    msg = "An error occurred";
  } else {
    const errors = ((((err || {}).response || {}).data || {}).errors || {})
      .message;
    if (typeof errors !== "undefined") {
      msg = errors[0];
    } else if (defaultMsg) {
      msg = defaultMsg;
    } else {
      msg = "An error occurred";
    }
  }
  toast.show("error", msg);
}



// WEBPACK FOOTER //
// ./src/http-helper.js